import ConsumablesPage from '@/pages/ConsumablesPage/ConsumablesPage';

export default ConsumablesPage;
